import { del, get, post } from '../requestNew';
import { ApiResp, ChatMessage, ChatSession, SendResult } from './types';

const API = '/image-chat';

export const fetchSessions = () => get<ApiResp<ChatSession[]>>(`${API}/sessions`);

export const createSession = () => post<ApiResp<{ id: number }>>(`${API}/sessions`, {});

export const deleteSession = (id: number) => del<ApiResp<null>>(`${API}/sessions/${id}`);

export const fetchMessages = (id: number) => get<ApiResp<ChatMessage[]>>(`${API}/sessions/${id}/messages`);

export const sendMessage = (id: number, body: Record<string, any>) =>
  post<ApiResp<SendResult>>(`${API}/sessions/${id}/messages`, body);

// 轮询失败不弹全局提示，避免长任务期间刷屏
export const fetchMessage = (id: number) => get<ApiResp<ChatMessage>>(`${API}/messages/${id}`, {}, () => {});

export const retryMessage = (id: number) => post<ApiResp<null>>(`${API}/messages/${id}/retry`, {});
